/**
Author - Kaustubh Mishra
Git - https://github.com/KaustubhMishra25
**/

import React from 'react';

import styled from 'styled-components';

import Spinner from '../Spinner';

const ActionButtonSecondary = ({
  buttonText,
  callback,
  additionalStyles,
  isLoading,
  isDisabled,
  className = '',
}) => (
  <ButtonContainer
    disabled={isDisabled}
    style={{...additionalStyles}}
    onClick={callback}
    className={className}
  >
    {isLoading ? <Spinner className="spinner-container" /> : buttonText}
  </ButtonContainer>
);

const ButtonContainer = styled.button.attrs({
  className: 'action-button',
})`
  padding: 1rem 0;
  background: #ffffff;
  border-radius: 52px !important;
  border: 1px solid ${(props) => props.theme.colors.brand.primary};
  width: 100%;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.brand.primary};
  max-height: 42px;

  :disabled {
    background-color: rgb(236, 236, 236);
    color: rgb(161, 161, 161);
    pointer-events: none;
  }

  :hover {
    scale: 1.02;
  }
  .spinner-container {
    margin: 0rem auto;
  }
`;

export default ActionButtonSecondary;
